/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRegionRequest
 */
export interface CreateRegionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRegionRequest
     */
    carrierRegion: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegionRequest
     */
    mccMnc: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegionRequest
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegionRequest
     */
    timezoneName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegionRequest
     */
    carrierName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRegionRequest
     */
    timezoneLongName: string;
}

/**
 * Check if a given object implements the CreateRegionRequest interface.
 */
export function instanceOfCreateRegionRequest(value: object): value is CreateRegionRequest {
    if (!('carrierRegion' in value) || value['carrierRegion'] === undefined) return false;
    if (!('mccMnc' in value) || value['mccMnc'] === undefined) return false;
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('timezoneName' in value) || value['timezoneName'] === undefined) return false;
    if (!('carrierName' in value) || value['carrierName'] === undefined) return false;
    if (!('timezoneLongName' in value) || value['timezoneLongName'] === undefined) return false;
    return true;
}

export function CreateRegionRequestFromJSON(json: any): CreateRegionRequest {
    return CreateRegionRequestFromJSONTyped(json, false);
}

export function CreateRegionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRegionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carrierRegion': json['carrier_region'],
        'mccMnc': json['mcc_mnc'],
        'locale': json['locale'],
        'timezoneName': json['timezone_name'],
        'carrierName': json['carrier_name'],
        'timezoneLongName': json['timezone_long_name'],
    };
}

export function CreateRegionRequestToJSON(json: any): CreateRegionRequest {
    return CreateRegionRequestToJSONTyped(json, false);
}

export function CreateRegionRequestToJSONTyped(value?: CreateRegionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier_region': value['carrierRegion'],
        'mcc_mnc': value['mccMnc'],
        'locale': value['locale'],
        'timezone_name': value['timezoneName'],
        'carrier_name': value['carrierName'],
        'timezone_long_name': value['timezoneLongName'],
    };
}

